import 'css-chunksrc/client/pages/projectPage/wbsPage/statuses/tasks/task/styles.scss';export default {
  "task": "_task_1pq2o_1",
  "name": "_name_1pq2o_12",
  "icon": "_icon_1pq2o_27",
  "status": "_status_1pq2o_43",
  "allocations": "_allocations_1pq2o_50",
  "text": "_text_1pq2o_57",
  "taskAdvancement": "_taskAdvancement_1pq2o_63",
  "taskAdvancementWrapper": "_taskAdvancementWrapper_1pq2o_69",
  "tick": "_tick_1pq2o_74",
  "late": "_late_1pq2o_81",
  "contextualMenu": "_contextualMenu_1pq2o_85"
};